import clsx from "clsx";
import React from "react";
import { Path, UseFormRegister } from "react-hook-form";

import RadioButton from "components/RadioButton";
import RequiredBadge from "components/RequiredBadge";
import { STRING_BOOLEAN, StringBoolean } from "constants/primitive";
import { CompanyFormConfigInputs } from "lib/types/form.setting.d";

const { TRUE, FALSE } = STRING_BOOLEAN;

export const FormSettingColumn = ({
  legalName,
  personName,
  isLast = false,
  field,
  defaultValue,
  register,
  watch,
  noField = false,
  minWidthRadio,
}: {
  legalName: string;
  personName: string;
  isLast?: boolean;
  field: Path<CompanyFormConfigInputs>;
  defaultValue?: StringBoolean;
  register: UseFormRegister<CompanyFormConfigInputs>;
  watch: (fieldName: Path<CompanyFormConfigInputs>) => StringBoolean;
  noField?: boolean;
  minWidthRadio?: string;
}) => {
  return (
    <div className={clsx("flex h-[56px] items-center px-6 text-s", isLast ? "" : "border-b")}>
      <span className="min-w-[230px]">{legalName}</span>
      <span className="min-w-[230px]">{personName}</span>
      <RequiredBadge isActive={noField ? noField : watch(field) === TRUE} />
      {!noField && (
        <div className="ml-[114px]">
          <RadioButton<CompanyFormConfigInputs>
            defaultValue={defaultValue}
            name={field}
            register={register}
            options={[
              { label: "必須", value: TRUE },
              { label: "任意", value: FALSE },
            ]}
            minWidth={minWidthRadio}
            direction="horizontal"
          />
        </div>
      )}
    </div>
  );
};
